<div [ngStyle]="safeStyle" [ngClass]="class" ><ng-content></ng-content></div>
